import { DashboardModule, Form } from '@domain-group/suit-theme'

import EntitySelectBox from '@components/EntitySelectBox'

import type { UseBrandFormPayload } from '@hooks/useBrand'

interface BrandAddressProps {
  brandFormPayload: UseBrandFormPayload,
}

const BrandAddress = (props: BrandAddressProps) => {
  const { brandFormPayload } = props || {}
  const {
    entityState: {
      address_line_1,
      address_line_2,
      address_postcode,
      address_region,
      address_state,
      geo_country_id,
    },
    errors,
    handlers,
  } = brandFormPayload

  return (
    <DashboardModule title="Address">
      <Form padding="large">
        <Form.Row>
          <Form.Field errorMessage={errors.address_line_1} label="* Address Line 1">
            <input
              name="address_line_1"
              type="text"
              value={address_line_1}
              {...handlers}
            />
          </Form.Field>

          {/*
           // @ts-expect-error TS2322 */}
          <Form.Field label="Address Line 2" marginTop={['large', 0]}>
            <input
              name="address_line_2"
              type="text"
              value={address_line_2}
              {...handlers}
            />
          </Form.Field>
        </Form.Row>

        <Form.Row marginTop="large">
          <Form.Field errorMessage={errors.address_region} label="* Suburb/Region">
            <input
              name="address_region"
              type="text"
              value={address_region}
              {...handlers}
            />
          </Form.Field>

          {/*
           // @ts-expect-error TS2339 */}
          <Form.Field errorMessage={errors.address_postcode} label="* Post Code" marginTop={['large', 0]}>
            <input
              name="address_postcode"
              type="text"
              value={address_postcode}
              {...handlers}
            />
          </Form.Field>
        </Form.Row>

        <Form.Row marginTop="large">
          <Form.Field errorMessage={errors.address_state} label="* State">
            <input
              name="address_state"
              type="text"
              value={address_state}
              {...handlers}
            />
          </Form.Field>

          {/*
           // @ts-expect-error TS2339 */}
          <Form.Field errorMessage={errors.geo_country_id} label="* Country" marginTop={['large', 0]}>
            <EntitySelectBox
              data-value-type="number"
              entityKey="geoCountries"
              // @ts-expect-error TS2322
              name="geo_country_id"
              sortDirection="asc"
              sortKey="title"
              value={geo_country_id}
              {...handlers}
            />
          </Form.Field>
        </Form.Row>
      </Form>
    </DashboardModule>
  )
}

export default BrandAddress
